import { Space, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  HAS_TASKS_RADIO_OPTIONS,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';

export const HasTasksSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeFilterById } = useNewClientsListContext();

  const { hasTasks } = filtersMap.get(id)!;

  const selected = hasTasks !== null && hasTasks !== undefined;

  const tagLabel = useMemo(() => {
    return HAS_TASKS_RADIO_OPTIONS.find((option) => option.value === hasTasks)
      ?.label;
  }, [hasTasks]);

  const onClose = useCallback(() => {
    onChangeFilterById(id, 'hasTasks', null);
  }, [onChangeFilterById, id]);

  if (!selected) {
    return null;
  }

  return (
    <Space className={`${PF}__tags`}>
      <Tag className={`${PF}__tag`} closable onClose={onClose}>
        {tagLabel}
      </Tag>
    </Space>
  );
};
